import { useNavigate } from 'react-router-dom'
import type { Project } from '../../api/types'
import PulseIcon from './PulseIcon'

export default function PulseHubTile({ project }: { project: Project }) {
  const navigate = useNavigate()
  return (
    <button
      type="button"
      className="pulse-hub-tile"
      data-testid="pulse-hub-tile"
      aria-label="Pulse"
      onClick={() => navigate(`/projects/${project.id}/pulse`)}
    >
      <span className="pulse-hub-tile-icon">
        <PulseIcon size={32} />
      </span>
      <span className="pulse-hub-tile-label">Pulse</span>
    </button>
  )
}
